﻿import defaultApp from './defaultApp.js';

import NewsItem from './components/NewsItem.vue';

const newsApp = {
    ...defaultApp,
    components: {
        ...defaultApp.components,
        NewsItem,
    },
};

export default newsApp;
